/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `DropdownPositionType*`'s.
 */
export type DropdownPositionType = DropdownPositionLeft | DropdownPositionRight;

/**
 * The left position type.
 */
export type DropdownPositionLeft = typeof DROPDOWN_POSITION_LEFT;

/**
 * The right position type.
 */
export type DropdownPositionRight = typeof DROPDOWN_POSITION_RIGHT;

/**
 * The left position constant.
 */
export const DROPDOWN_POSITION_LEFT = `left`;

/**
 * The right position constant.
 */
export const DROPDOWN_POSITION_RIGHT = `right`;
